module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1009-7964638c9a4533dd97efa3d6bdf90e7a.png";